<template>
  <el-tabs v-model="gridKey">
    <el-tab-pane v-for="grid in grids"
                 :key="grid.value"
                 :name="grid.value"
                 :label="grid.label"
                 lazy>
      <TemplateDataGrid :ref="grid.value"
                        :gridId="grid.value"
                        @state-change="onStateChange"></TemplateDataGrid>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import TemplateDataGrid from '../../../../../../../templates/TemplateDataGrid'
import globalEvent from '../../../../../../../../constants/globalEvent'
export default {
  name: 'StatusChangeAuditRollClass',
  components: {
    TemplateDataGrid
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      grids: [{
        value: 'PeStudentChangeRollClassNotAudit',
        label: '转班待审核列表'
      }, {
        value: 'PeStudentChangeRollClassHasAudit',
        label: '转班已审核列表'
      }],
      gridKey: ''
    }
  },
  created () {
    this.gridKey = this.grids[0].value
  },
  methods: {
    reloadGridData () {
      if (this.active) {
        let gridKey = this.gridKey
        if (gridKey) {
          let grids = this.$refs[gridKey]
          if (grids && grids.length) {
            grids[0].loadGridData()
          }
        }
      }
    },
    onStateChange () {
      this.$emit('refresh')
    },
    bindEvent () {
      this.grids.forEach(grid => {
        this.$bus.$on(`${globalEvent.templateGrid.DATA_STATE_CHANGED}:${grid.value}`, this.onStateChange)
      })
    },
    unbindEvent () {
      this.grids.forEach(grid => {
        this.$bus.$off(`${globalEvent.templateGrid.DATA_STATE_CHANGED}:${grid.value}`, this.onStateChange)
      })
    }
  },
  mounted () {
    this.bindEvent()
  },
  beforeDestroy () {
    this.unbindEvent()
  },
  watch: {
    active: function () {
      this.reloadGridData()
    },
    gridKey: function () {
      this.reloadGridData()
    }
  }
}
</script>
